import { createContext } from 'react';
// set the defaults
const TableContext = createContext({
    tableSortOptions: {},
    updateTableSortOptions: (tableSortOptions) => {},
});

export default TableContext;
